import { Guid } from '@web/utils';
import { jsonMember, jsonObject } from 'typedjson';
import { WarehouseLocalizationContextOperationsResponse } from './warehouse-localization-context-operations.response';

@jsonObject
export class WarehouseLocalizationCollectionItemResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly label!: string;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(WarehouseLocalizationContextOperationsResponse)
  public readonly contextOperations!: WarehouseLocalizationContextOperationsResponse;
}
